/*
 * @Author: 戴旭
 * @Date: 2023-02-17 16:07:58
 * @LastEditTime: 2023-02-17 16:10:15
 * @LastEditors: 戴旭
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\cloud-visit\cloud-visit\module\dataManageRouter.js
 * 其他
 */

const otherRouter = [

  // 用户积分
  {
    path: '/outsideSystem/score',
    name: 'outsideSystemScoreList',
    component: () =>
      import(
        /*webpackChunkName:"outsideSystemDataScore" */
        // '@/views/outsideSystem/ScoreList' 待删除
        '@/views/cloud-visit/cloud-visit/other/user-integral/Page.vue'
        ),
    meta: {
      SecondaryMenu: '其它', //二级菜单
      title: '用户积分',
    },
  },


  // 系统设置
  {
    path: '/outsideSystem/setting',
    name: 'outsideSystemSetting',
    component: () =>
      import(
        /*webpackChunkName:"outsideSystemSetting" */
        // '@/views/outsideSystem/setting/List.vue' 待删除
        '@/views/cloud-visit/cloud-visit/other/system-setting/Page.vue'
        ),
    meta: {
      SecondaryMenu: '其它', //二级菜单
      title: '系统设置',
    },
  },


  // 系统设置 功能配置
  {
    path: '/outsideSystem/func-config',
    name: 'outsideSystemFuncConfig',
    component: () =>
      import(
        /*webpackChunkName:"outsideSystemSettingConfig" */
        // '@/views/outsideSystem/setting/FuncConfig.vue' 待删除
        '@/views/cloud-visit/cloud-visit/other/system-setting/function-setting/Page.vue'
        ),
    meta: {
      SecondaryMenu: '其它', //二级菜单
      title: '功能配置',
      breadcrumb: [{
        title: '系统设置',
        name: 'outsideSystemSetting',
      }, ],
    },
  },

  // 系统设置 积分设置
  {
    path: '/outsideSystem/score-setting',
    name: 'outsideSystemScoreSetting',
    component: () =>
      import(
        /*webpackChunkName:"outsideSystemSettingConfig" */
        // '@/views/outsideSystem/setting/ScoreList.vue' //待删除
        '@/views/cloud-visit/cloud-visit/other/system-setting/integral-setting/Page.vue'
        ),
    meta: {
      SecondaryMenu: '其它', //二级菜单
      title: '积分设置',
      breadcrumb: [{
        title: '系统设置',
        name: 'outsideSystemSetting',
      }, ],
    },
  },

]

export default otherRouter